import { combineEpics } from 'redux-observable';
import { getLeadsSummaryEpic } from './get-leads-summary';
import { resetOnLogoutEpic } from './reset-on-logout';
import { exportLeadsEpic } from './export-leads';

const leadsEpic = combineEpics(
  getLeadsSummaryEpic,
  resetOnLogoutEpic,
  exportLeadsEpic
);

export default leadsEpic;